// Checkbox > Checkbox
import React from 'react'
import { CheckboxProps, checkboxDefaultProps } from './ICheckbox'
import Text from '../Text'
import FlexBox from '../FlexBox'
import classNames from 'classnames'
import styles from './Checkbox.module.css'

class Checkbox extends React.PureComponent<CheckboxProps, {}> {
	static readonly defaultProps = checkboxDefaultProps

	private _handleRootClick = (event: React.MouseEvent<HTMLDivElement>) => {
		if (this.props.disabled) return

		this._handleCheckboxOnChange(event)
	}

	private _handleCheckboxOnChange = (
		event: React.ChangeEvent<HTMLInputElement> | React.MouseEvent<HTMLDivElement>
	) => {
		event.stopPropagation()
		const { value, handleRootClick } = this.props

		handleRootClick && handleRootClick(value ? value.toString() : '')
	}

	private _handleCheckboxClick = (event: React.MouseEvent<HTMLInputElement>) => {
		event.stopPropagation()
	}

	render() {
		const { type, name, value, handleRootClick, ...rest } = this.props

		if (!value) {
			console.warn('Checkbox hidden. No value provided')
		}

		return value ? (
			<FlexBox
				container
				alignItems="center"
				onClick={this._handleRootClick}
				className={classNames(styles.root, { [styles.disabled]: rest.disabled })}
			>
				<input
					type="checkbox"
					value={value.toString()}
					{...rest}
					onChange={this._handleCheckboxOnChange}
					onClick={this._handleCheckboxClick}
					className={classNames(styles.input, { [styles.disabled]: rest.disabled })}
				/>
				<Text>{name}</Text>
			</FlexBox>
		) : null
	}
}

export default Checkbox
